module.exports = __webpack_public_path__ + "static/media/estagio.9192f21f.png";